import { Controller } from '@hotwired/stimulus'

export default class SyncSettingsController extends Controller<HTMLElement> {
  declare actionsTarget: HTMLElement
  declare enableToggleTarget: HTMLInputElement
  declare timeTarget: HTMLInputElement
  declare timeZoneTarget: HTMLSelectElement
  declare toggleTarget: HTMLSelectElement

  declare isEnabledValue: boolean

  declare disabledClasses: Array<string>

  static classes = ['disabled']

  static targets = ['actions', 'enableToggle', 'time', 'timeZone']

  static values = {
    isEnabled: Boolean,
  }

  actionsTargetConnected(el: HTMLElement) {
    el.classList.add('hidden')
  }

  checkRow(event: Event) {
    if (event.target.closest('input')) return
    const checkbox = event.currentTarget.querySelector('[type="checkbox"]')
    if (!checkbox) return
    checkbox.checked = !checkbox.checked
    checkbox.dispatchEvent(new Event('change', { bubbles: true }))
  }

  // goofy reset hook because turbo gets into a weird state sometimes when the page is refreshed
  enableToggleTargetConnected(el: HTMLSelectElement) {
    Array.from(el.options).forEach(opt => {
      opt.selected = opt.value === this.isEnabledValue.toString()
    })
    this.isEnabledValueChanged()
  }

  isEnabledValueChanged() {
    const action = this.isEnabledValue ? 'remove' : 'add'
    if (this.hasTimeTarget) this.timeTarget.classList[action](...this.disabledClasses)
    if (this.hasTimeZoneTarget) this.timeZoneTarget.classList[action](...this.disabledClasses)
  }

  setIsEnabled() {
    this.isEnabledValue = this.enableToggleTarget.value === 'true'
  }

  setIsModified() {
    if (this.actionsTarget.classList.contains('hidden')) {
      this.actionsTarget.classList.remove('hidden')
      this.#toggleActions()
    }
  }

  resetIsModified() {
    this.#toggleActions('reverse').finished.then(() => {
      this.actionsTarget.classList.add('hidden')
      this.setIsEnabled()
    })
  }

  #toggleActions(direction?: PlaybackDirection) {
    direction ??= 'normal'
    const options = {
      direction,
      duration: 300,
      easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
      fill: 'both',
    }
    return this.actionsTarget.animate([{ opacity: 0 }, { opacity: 1 }], options)
  }
}
